import {
  fetchAll,
  createDocWithId,
  updateDocById,
  deleteDocById,
} from "./firestoreHelpers";

const COLL = "alquileres_gastos";

// Each entry: { idFirebase, contratoId, locadorNombre, locatarioNombre, propiedad,
//   descripcion, monto, fecha, mes, anio, categoria, pagadoPor (PROPIETARIO/INMOBILIARIA/INQUILINO) }
export const getGastos = async () => fetchAll(COLL);

export const saveGasto = async (data) => createDocWithId(COLL, data);

export const updateGasto = async (id, data) => updateDocById(COLL, id, data);

export const deleteGasto = async (id) => deleteDocById(COLL, id);
